import {storyblokEditable, useStoryblokApi} from "@storyblok/react";
import Image from "next/image";
import Link from "next/link";
import classNames from "classnames";
import ButtonGroup from "../partials/ButtonGroup";
import {transformImage} from "../../utils/StoryblokService";
import LinePattern from "../partials/LinePattern";
import {richTextResolver} from "@storyblok/richtext";

export default function TwoColumnQuoteSection(props: { blok: any }) {
    const { render } = richTextResolver()
    const blok = props.blok;
    const buttons = <ButtonGroup buttons={blok.buttons}/>

    return (
        <div className={classNames("overflow-hidden", blok.class, blok.container_padding || "padding-normal")} {...storyblokEditable(blok)}>
            <div className={"mx-auto space-y-8 px-4 sm:px-6 lg:px-8 " + (blok.container_size || 'max-w-screen-2xl')}>
                <div className="lg:grid lg:grid-cols-2 lg:items-start lg:gap-14">
                    <div className={classNames({"relative z-10": true, "col-span-2": !blok.show_quote})}>
                        <div className="mx-auto max-w-prose text-base lg:max-w-none">
                            <p className="text-lg font-semibold text-secondary">
                                {blok.subtitle}
                            </p>
                            <h2 className={"mt-2 font-bold leading-8 tracking-tight text-gray-900 "+blok.titlesize}>
                                {blok.title}
                            </h2>
                        </div>
                        <div className="relative z-10 mx-auto max-w-prose text-base lg:mx-0 lg:max-w-5xl lg:pr-16">
                            <p className="text-lg text-gray-700">
                                {blok.intro}
                            </p>
                        </div>

                        <div className="prose prose-secondary mx-auto text-gray-500 lg:max-w-none ">
                            <div className=""
                                 dangerouslySetInnerHTML={{
                                     __html: render(blok.text) as string
                                 }}
                            >
                            </div>
                        </div>
                        <div className="mx-auto mt-10 flex max-w-prose text-base lg:max-w-none gap-4">
                            {buttons}
                        </div>
                    </div>
                    {blok.show_quote &&
                    <div
                        data-aos={'slide-left'}
                        className="relative mx-auto mt-12 max-w-prose text-base lg:mt-0 lg:max-w-none self-center">

                            <blockquote
                                className="relative rounded-lg bg-white shadow-lg hover:shadow-2xl transition-all duration-500">
                                <div className="rounded-t-lg px-6 py-8 sm:px-10 sm:pt-10 sm:pb-8">
                                    {blok.show_logo &&
                                        <img
                                            className="block h-12 w-auto"
                                            src={'/images/SVG/logo_v3.svg'}
                                            alt="Pacific Codeline LLC Logo"
                                        />}
                                    <div className="relative mt-8 text-lg text-gray-700">

                                        <div className={'grid grid-cols-3 items-center gap-4'}>
                                            <p className={classNames({'relative': true, 'col-span-2': blok.image.id, 'col-span-3': !blok.image.id})}>
                                                {blok.quote}
                                            </p>
                                            {blok.image.id && blok.image.filename &&
                                                <Image
                                                    src={transformImage(blok.image.filename, blok.imagesize)}
                                                    className={"w-full rounded-lg shrink-0"}
                                                    alt={blok.image.alt}
                                                    width={500}
                                                    height={400}
                                                />}
                                        </div>
                                    </div>
                                </div>
                                {blok.show_author &&
                                    <cite
                                        className="relative flex items-center rounded-b-lg bg-primary py-5 px-6 not-italic sm:mt-10 sm:items-start sm:py-5 sm:pl-12 sm:pr-10">

                                        {blok.quote_image?.filename &&
                                            <span
                                                className="relative rounded-full border-2 border-white sm:absolute sm:top-0 sm:-translate-y-1/2 sm:transform aspect-square shrink-0">
                  <Image
                      className="h-12 w-12 rounded-full bg-white sm:h-20 sm:w-20 object-contain"
                      src={transformImage(blok.quote_image.filename, blok.quote_imagesize || 'fit-in/250x250/filters:fill(transparent):format(png)')}
                      width={250}
                      height={250}
                      alt=""
                  />
                </span>}
                                        <span
                                            className={"relative leading-6 text-secondary sm:pl-1 " + ((blok.quote_image?.id) ? 'ml-4 sm:ml-24' : '')}>

                  <span className=" text-white sm:inline">
                      {blok.quote_person_name}
                  </span>{' '}
                                            <span className="sm:inline text-sm">
                                                {blok.quote_company}
                                            </span>
                </span>
                                    </cite>}
                            </blockquote>
                    </div>}
                </div>
            </div>
        </div>
    )
}
